import styles from './SectionOne.module.css';



export default function SectionOne() {

    return (

        <div className={`${styles.aboutSectionOne} row`}>

            <div className="col-lg-12 col-sm-12">

                <h1>About Us</h1>

                <p>We are a dedicated team committed to combating human
                    trafficking and fostering a world where dignity, freedom,
                    and opportunity are fundamental rights for all. Our mission
                    is to protect the vulnerable, empower survivors, and raise
                    awareness about the devastating impact of trafficking on individuals
                    and communities.

                    Through collaborative efforts, innovative campaigns, and unwavering advocacy, we strive to create
                    a safer society free from exploitation. Together, we can make a difference, one life at a time.</p>

            </div>




        </div>
    )
}